import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login";
import Soporte from "../components/Soporte_linea7x24";
import Graficos from "../components/Graficos";
import ControlPanel from "../components/ControlPanel";
// import Detalle_Pacientes_Programa from '../components/Detalle_pacientes_programa'
import HistoriaClinica from "../components/HistoriaClinica";
import HistoriaClinicaV3 from "../components/HistoriaClinicaV3";
import Mensajes from "../components/Mensajes";
import Agenda from "../components/Agenda";
import PanelAuxiliar from "../components/PanelAuxiliar";
import Sugerencias from "../components/Chatbox/Sugerencias/Sugerencias";
import TarjetasFormulario from "../components/Formulario/TarjetasFormulario";
import graficaGestion from "../components/Gestion/graficaGestion/graficaGestion";
import gestionAdministrativo from "../components/Gestion/gestionAdministrativo/gestionAdministrativo";
import GestionEstadosOrdenes from "../components/Gestion/GestionEstadosOrdenes/GestionEstadosOrdenes";
import formularioOverlay from "../components/formularioOverlay/formularioOverlay";
import Calendario from "../components/Calendario/Calendario";
import gestionRehabilitacion from "../components/Gestion/gestionRehabilitacion/gestionRehabilitacion";
import graficaRhb from "../components/Gestion/gestionRehabilitacion/graficaRhb/graficaRhb";
import graficaRhbAuxiliar from "../components/Gestion/gestionRehabilitacion/graficaAuxiliar/graficaAuxiliar";
import tablaRhb from "../components/Gestion/gestionRehabilitacion/tabla/tabla";
import TimeLine from "../components/TimeLine/TimeLine";
import CreacionHorarios from "../components/CreacionHorarios/CreacionHorarios";
import AnalisisDeFormulario from "../components/AnalisisDeFormulario/AnalisisDeFormulario";
import EnvioDeMensajes from "../components/EnvioDeMensajes/EnvioDeMensajes";
import Terapias from "../components/Terapias/Terapias";
import TerapiasPaciente from "../components/Terapias/TerapiasPaciente/TerapiasPaciente";
import TerapiasEsquema from "../components/Terapias/TerapiasEsquema/TerapiasEsquema";
import MensajesMasivos from "../components/MensajesMasivos/MensajesMasivos";
import Listas from "../components/Listas/Listas.vue";

Vue.use(VueRouter);

export default new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: "/gestionRehabilitacion",
      component: gestionRehabilitacion,
      children: [
        {
          path: "/gestionRehabilitacion/graficaRhb/:graficaRhbId",
          name: "graficaRhb",
          component: graficaRhb,
          children: [
            {
              path:
                "/gestionRehabilitacion/graficaRhb/:graficaRhbId/graficaRhbAuxiliar",
              name: "graficaRhbAuxiliar",
              component: graficaRhbAuxiliar,
              children: [
                {
                  path:
                    "/gestionRehabilitacion/graficaRhb/:graficaRhbId/graficaRhbAuxiliar/tablaRhb",
                  name: "tablaRhb",
                  component: tablaRhb
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/envio",
      name: "Envio",
      component: EnvioDeMensajes
    },
    {
      path: "/terapias",
      name: "Terapias",
      component: Terapias,
      children: [
        {
          path: "",
          name: "parent",
          redirect: { name: "Pacientes" }
        },
        {
          path: "/terapias/pacientes",
          name: "Pacientes",
          component: TerapiasPaciente
        },
        {
          path: "/terapias/esquemas",
          name: "Esquemas",
          component: TerapiasEsquema
        },
        {
          path: "/terapias/masivos",
          name: "MensajesMasivos",
          component: MensajesMasivos
        },
        {
          path: "/terapias/listas",
          name: "Listas",
          component: Listas
        },
        {
          path: "**",
          name: "parent",
          redirect: { name: "Pacientes" }
        }
      ]
    },
    {
      path: "/AnalisisDeFormulario",
      name: "AnalisisDeFormulario",
      component: AnalisisDeFormulario,
      children: [
        {
          path: "/AnalisisDeFormulario/EnvioDeMensajes",
          name: "EnvioDeMensajes",
          component: EnvioDeMensajes
        }
      ]
    },
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/calendario",
      name: "calendario",
      component: Calendario
    },
    {
      path: "/CreacionHorarios",
      name: "CreacionHorarios",
      component: CreacionHorarios
    },
    {
      path: "/soporte",
      name: "Soporte",
      component: Soporte
    },
    {
      path: "/graficos",
      name: "graficos",
      component: Graficos
    },
    {
      path: "/ControlPanel",
      name: "controlPanel",
      component: ControlPanel
    },
    {
      path: "/HistoriaClinicaV3",
      name: "HistoriaClinicaV3",
      component: HistoriaClinicaV3
    },
    {
      path: "/HistoriaClinica",
      name: "historiaClinica",
      component: HistoriaClinica,
      children: [
        {
          path: "/HistoriaClinica/TimeLine",
          name: "TimeLine",
          component: TimeLine
        }
      ]
    },
    {
      path: "/Mensajes",
      name: "mensajes",
      component: Mensajes
    },
    {
      path: "/Agenda",
      name: "agenda",
      component: Agenda
    },
    {
      path: "/PanelAuxiliar",
      name: "panelAuxiliar",
      component: PanelAuxiliar
    },
    {
      path: "/sugerencias",
      name: "Sugerencias",
      component: Sugerencias
    },
    {
      path: "/tarjetasFormulario",
      name: "TarjetasFormulario",
      component: TarjetasFormulario
    },
    {
      path: "/graficaGestion",
      name: "graficaGestion",
      component: graficaGestion
    },
    {
      path: "/formularioOverlay",
      name: "formularioOverlay",
      component: formularioOverlay
    },
    {
      path: "/gestionAdministrativo",
      name: "gestionAdministrativo",
      component: gestionAdministrativo
    },
    {
      path: "/gestionOrdenes",
      name: "gestionEstadosOrdenes",
      component: GestionEstadosOrdenes
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js